import { render, staticRenderFns } from "./preview-img-new.vue?vue&type=template&id=3eda071c"
import script from "./preview-img-new.vue?vue&type=script&lang=js"
export * from "./preview-img-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports